const SELECTORS = {
  mainBoostSearchWrapperID: 'boost-sd__instant-search-container',
  desktopSearchWrapper: 'boost-sd__search-bar-wrapper--desktop',
  mobileSearchWrapper: 'boost-sd__search-bar-wrapper--mobile',
  searchTogglers: '[data-toggle-boost-search]',
  boostHiddenClass: 'boost-sd__g-hide',
  bodySearchActiveClass: 'boost-sd__search-active',
  header: '.header-sticky-wrapper',
};
const observerConfig = {
  childList: true, // Observe changes in the child nodes
  subtree: true, // Observe changes in all descendants of the target
};

/**
 * @param {HTMLElement} searchWidget - widget container
 */
const setSearchPosition = (searchWidget) => {
  const widget = searchWidget;
  const headerRect = document.querySelector(SELECTORS.header)?.getBoundingClientRect();
  let topElementsHeight = headerRect.height;
  if (headerRect.top >= 0) {
    topElementsHeight += headerRect.top;
  }
  const screenHeight = screen.height - topElementsHeight;
  widget.style.height = `${screenHeight}px`;
  widget.style.top = `${topElementsHeight}px`;
};
/**
 *  Open boost search
 *
 * @param {HTMLElement} searchWidget - widget container
 */
const openToggleSearch = (searchWidget) => {
  setSearchPosition(searchWidget);
  searchWidget.classList.toggle(SELECTORS.boostHiddenClass);
};

/**
 * @param {HTMLElement} searchWidget - widget container
 */
const eventsListeners = (searchWidget) => {
  const openSearchTriggers = document.querySelectorAll(SELECTORS.searchTogglers);
  if (openSearchTriggers.length > 0) {
    openSearchTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openToggleSearch(searchWidget, trigger);
      });
    });
  }
  document.addEventListener('scroll', () => {
    setSearchPosition(searchWidget);
  });
};
/**
 * Wait for main search results wrappers
 *
 * @param {HTMLElement} boostWrapper - boost body wrapper
 */
const observeSearchWrapper = (boostWrapper) => {
  const searchWrapperInitObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && (node.classList.contains(SELECTORS.desktopSearchWrapper) || node.classList.contains(SELECTORS.mobileSearchWrapper))) {
            eventsListeners(node);
            searchWrapperInitObserver.disconnect();
          }
        });
      }
    });
  });
  searchWrapperInitObserver.observe(boostWrapper, observerConfig);
};
/**
 * Observe body to render boost widgets
 */
const bodyBoostWrapperObserver = () => {
  const boostObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.id === SELECTORS.mainBoostSearchWrapperID) {
            observeSearchWrapper(node);
            boostObserver.disconnect();
          }
        });
      }
    });
  });
  boostObserver.observe(document.body, observerConfig);
};

document.addEventListener('DOMContentLoaded', () => {
  const instantMainSearchWrapper = document.getElementById(SELECTORS.mainBoostSearchWrapperID);
  if (instantMainSearchWrapper) {
    observeSearchWrapper(instantMainSearchWrapper);
  }
  bodyBoostWrapperObserver();
});
